"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContactsService = void 0;
const generate_contact_1 = require("../lib/contacts/generate-contact");
const generate_contacts_1 = require("../lib/contacts/generate-contacts");
class ContactsService {
    _data = [];
    _eventName = 'contacts';
    _subscribers = {};
    _contactOptions = {};
    _subscribeOptions = {};
    constructor(options) {
        this._contactOptions = {
            alertsPercentage: options?.alertsPercentage,
            dateRef: options?.dateRef,
            daysRange: options?.daysRange,
            secondAlertPercentage: options?.secondAlertPercentage,
        };
        this._subscribeOptions = {
            initial: options?.initial,
            interval: options?.interval,
            limit: options?.limit,
        };
    }
    _findIndex(id) {
        return this._data.findIndex((contact) => contact.id === id);
    }
    _publish(contacts) {
        if (!Array.isArray(this._subscribers[this._eventName]))
            return;
        this._subscribers[this._eventName].forEach((callback) => {
            callback(contacts);
        });
    }
    subscribe(callback) {
        if (!Array.isArray(this._subscribers[this._eventName])) {
            this._subscribers[this._eventName] = [];
        }
        this._subscribers[this._eventName].push(callback);
        const initial = this._subscribeOptions.initial;
        this._data = (0, generate_contacts_1.generateContacts)(initial, this._contactOptions);
        this._publish(this._data);
        const limit = this._subscribeOptions.limit || 200;
        const index = this._subscribers[this._eventName].length - 1;
        const interval = setInterval(() => {
            if (this._data.length >= limit)
                return;
            this.addContact();
        }, (this._subscribeOptions.interval || 5) * 1000);
        return () => {
            clearInterval(interval);
            this._subscribers[this._eventName].splice(index, 1);
            this._data = [];
        };
    }
    addContact() {
        const index = this._data.length - 1;
        const addedContact = (0, generate_contact_1.generateContact)(index, this._contactOptions);
        this._data = [...this._data, addedContact];
        this._publish(this._data);
        return addedContact;
    }
    updateContact(id, params) {
        const index = this._findIndex(id);
        Object.entries(params).forEach(([key, value]) => {
            // @ts-expect-error key will be a contact property
            this._data[index][key] = value;
        });
        this._publish(this._data);
        return `Successfully modified contact: ${id}`;
    }
    deleteContact(id) {
        const index = this._findIndex(id);
        this._data.splice(index, 1);
        this._publish(this._data);
        return `Successfully deleted contact: ${id}`;
    }
}
exports.ContactsService = ContactsService;
